import { render, staticRenderFns } from "./parameterManage.vue?vue&type=template&id=007f627d&scoped=true"
import script from "./parameterManage.vue?vue&type=script&lang=js"
export * from "./parameterManage.vue?vue&type=script&lang=js"
import style0 from "./parameterManage.vue?vue&type=style&index=0&id=007f627d&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007f627d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('007f627d')) {
      api.createRecord('007f627d', component.options)
    } else {
      api.reload('007f627d', component.options)
    }
    module.hot.accept("./parameterManage.vue?vue&type=template&id=007f627d&scoped=true", function () {
      api.rerender('007f627d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/_homeCloudPlatform/parameter/parameterManage.vue"
export default component.exports